export default __webpack_public_path__ + "static/media/P-042.87598ea8.png";